import { IApplicationState } from '../../types/redux';

export function selectAllEstimation(state: IApplicationState) {
  return state.estimation;
}
